// Consent cookie and answer changes (WEB-4). Plain module (no React): the banner calls setConsent,
// Analytics.jsx and ConsentBanner.jsx read the cookie and listen for CONSENT_EVENT.
import Cookies from 'js-cookie'
import { getMeasurementId, isGa4Started, stopGa4 } from './ga4'

// Same cookie as the former react-cookie-consent banner.
export const COOKIE_NAME = 'martintamm-cookie-consent'
// Fired on window after every answer; listeners re-read the cookie (the single source of truth).
export const CONSENT_EVENT = 'martintamm:consent'
const EXPIRES_DAYS = 365
const GA_COOKIE = /^_ga($|_)/

let reloading = false

// Expires `_ga` and `_ga_<ID>` only (never `_gid`, `_gac_*` or other cookies), on the host and on every
// parent domain with at least two labels, because GA's `cookie_domain: auto` sets them on the
// registrable domain (`.mtamm.eu`). The browser ignores a Domain it rejects (a public suffix): harmless.
export function deleteGaCookies() {
  const names = document.cookie
    .split(';')
    .map((part) => part.split('=')[0].trim())
    .filter((name) => GA_COOKIE.test(name))
  if (names.length === 0) return

  const labels = window.location.hostname.split('.')
  const domains = [null]
  for (let i = 0; i <= labels.length - 2; i++) domains.push(labels.slice(i).join('.'))
  // GA writes its cookies with SameSite=None;Secure; on https the expiry must match to be accepted.
  const flags = window.location.protocol === 'https:' ? '; Secure; SameSite=None' : ''

  for (const name of names) {
    for (const domain of domains) {
      document.cookie = `${name}=; Max-Age=0; path=/${domain ? `; domain=${domain}` : ''}${flags}`
    }
  }
}

function reloadOnce() {
  if (reloading) return
  reloading = true
  window.location.reload()
}

// Stores the answer ('true' / 'false') for a new 365 days. Decline after gtag.js was loaded: stop GA
// before anything else can fire, delete its cookies, then reload once so no Google code stays in the
// page. Without a loaded gtag.js (or without a GA ID) nothing reloads.
export function setConsent(value) {
  const wasLoaded = isGa4Started()
  Cookies.set(COOKIE_NAME, value, {
    expires: EXPIRES_DAYS,
    sameSite: 'lax',
    secure: window.location.protocol === 'https:'
  })

  if (value === 'false') {
    if (wasLoaded) stopGa4(getMeasurementId())
    deleteGaCookies()
  }
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT))

  if (value === 'false' && wasLoaded) reloadOnce()
}

// Another tab may have withdrawn consent while this one still has gtag.js loaded (Q3). Called when the
// tab becomes visible and before each page view: if the cookie no longer says 'true', withdraw here
// too (stop GA, delete its cookies, reload once). Returns true while consent still holds.
export function enforceConsent() {
  if (Cookies.get(COOKIE_NAME) === 'true') return true
  if (isGa4Started()) {
    stopGa4(getMeasurementId())
    deleteGaCookies()
    reloadOnce()
  }
  return false
}
